import { render, staticRenderFns } from "./StatsColumn.vue?vue&type=template&id=1659397b&"
import script from "./StatsColumn.vue?vue&type=script&lang=js&"
export * from "./StatsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports